import axios from "axios"
import { Routes } from "../../data/routes"

export enum FacebookEvents {
  Selbstcheck = "Selbstcheck",
  UnfittingLead = "UnfittingLead",
  MatchingLead = "MatchingLead",
}

const pixelId = "947059467772696"
const accessToken =
  "EAAcFZBDKdjMkBREdx3zv0KhilPxqLEsvkTg3sJHJsYyBMO2AJgfh9UTYWsW6QG2hFhyT5bQ0P1s72cKzJeVmngUlRfmBQrMWZANCyXGxfk1bZCsoZBH3g3CcZAAhmDUef5B6MZC9hI16ziQbqukvUgYOsASR2RdbLzHkVFdHITg3UdMZAZBCZAsfYVaZAjCuXhNgZDZD"

export async function sendFacebookEvent(event: FacebookEvents) {

  return Promise.resolve()
  // console.log("Sending Facebook event")
  // try {
  //   const res = await axios.post(`https://graph.facebook.com/v18.0/${pixelId}/events?access_token=${accessToken}`, {
  //     data: [
  //       {
  //         event_name: event,
  //         event_time: Math.floor(Date.now() / 1000),
  //         action_source: "website",
  //         event_source_url: window.location.href,
  //         user_data: {
  //           client_user_agent: navigator.userAgent,
  //         },
  //       },
  //     ],
  //   })
  //   return console.log(res.data)
  // } catch (err) {
  //   return console.error(err.response.data)
  // }
}